/**
 * Logic for the evse/connector status based on the object returned from the
 * detail endpoint `stations/:id` (used by the sidebar).
 * The same logic is used in web otp.
 *
 * @param {object} evse - the evse object (numeric `status`, `operativeStatus`)
 * @param {object} connector - a connector of that evse (`status`, `operativeStatus`)
 * @returns {'available'|'occupied'|'charging'|'unavailable'|'connected'|'reserved'}
 */
const getEvseStatus = (evse, connector) => {
  // Legacy disconnected check
  if (evse.status === 0) {
    return 'unavailable';
  }

  // Connector inoperative
  if (connector.status === 'Inoperative') {
    return 'unavailable';
  }

  // Unavailable/Faulted at connector level
  if (['Unavailable', 'Faulted'].includes(connector.operativeStatus)) {
    return 'unavailable';
  }

  // Reserved — use EVSE level operativeStatus (not connector)
  if (evse.operativeStatus === 'Reserved') {
    return 'reserved';
  }

  // Charging — use EVSE level operativeStatus
  if (evse.operativeStatus === 'Charging') {
    return 'charging';
  }

  // Other occupied states — use EVSE level operativeStatus
  if (['Occupied', 'Finishing', 'SuspendedEVSE', 'SuspendedEV'].includes(evse.operativeStatus)) {
    return 'occupied';
  }

  // Legacy fallback: evse.status === 2 with connector showing Available
  if (evse.status === 2 && connector.operativeStatus === 'Available') {
    return 'occupied';
  }

  // Connected states — connector level
  if (['Preparing', 'EVConnected'].includes(connector.operativeStatus)) {
    return 'connected';
  }

  // Available states
  if (['Available', 'NoStatus', 'NoError', 'Idle'].includes(connector.operativeStatus)) {
    return 'available';
  }

  return 'unavailable';
};

export default getEvseStatus;
